import type { CSSProperties, FC, ReactNode } from 'react';

export type SearchAdServerIntegrationLayoutProps = {
  mountPointId: string;
  children?: ReactNode;
};

interface CssWithCustomProperties extends CSSProperties {
  '--top-spacing': string;
}

export const SearchAdServerIntegrationLayout: FC<SearchAdServerIntegrationLayoutProps> = ({
  mountPointId,
  children,
}) => {
  const style: CssWithCustomProperties = {
    '--top-spacing': '44px', // for vertical alignment with the top of the FilterSettings component
  };

  return (
    <div
      style={style}
      className="absolute top-0 right-[calc(-160px-0.5rem)] h-full pt-(--top-spacing) pl-2"
    >
      {children}
      <div
        role="marquee"
        className="sticky top-(--top-spacing) min-h-[600px] w-[160px]" // add `border border-[red]` for local testing, because GTM is not available locally
      >
        <div id={mountPointId} />
      </div>
    </div>
  );
};
